import React, { PropTypes } from 'react';

const icons = {
  white: {
    // insta: require('./insta-white.svg'),
    youtube: require('./youtube-white.svg'),
  },
  black: {
    // insta: require('./insta-black.svg'),
    youtube: require('./youtube-black.svg'),
  },
}

export default class Socials extends React.Component {

  static propTypes = {
    light: PropTypes.bool,
  };

  render() {
    require('./Socials.styl');
    const { light = false } = this.props;
    const currentIcons = icons[light ? 'white' : 'black'];
    return (
      <div className={`Socials ${light ? 'Socials--light' : ''}`}>
        {/* <span className="Socials__label">
          БАЙКАЛ430 в соцсетях
        </span> */}
        {/* <a href="https://www.instagram.com/baikal430/" target="_blank" className="Socials__link">
          <img src={currentIcons.insta} alt="Instagram" width={16} height={16} />
        </a> */}
        {/* <a href="https://www.youtube.com/channel/UCi3mhLeezNhneUy6f0P8y0Q" target="_blank" className="Socials__link">
          <img src={currentIcons.youtube} alt="Youtube" width={20} height={15} />
        </a> */}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Socials/Socials.js